"use strict";

const MODAL_SELECTOR = "[data-flexcontent-video-modal]";

function getPlayer(modal) {
    return modal.querySelector(".flexcontent-video-player");
}

function ensureSource(player) {
    if (!(player instanceof HTMLVideoElement)) {
        return;
    }

    if (player.querySelector("source")) {
        return;
    }

    const src = player.dataset.src;
    const type = player.dataset.type || "video/mp4";

    if (!src) {
        return;
    }

    const source = document.createElement("source");
    source.src = src;
    source.type = type;
    player.appendChild(source);
    player.load();
}

function playPlayer(player) {
    if (!(player instanceof HTMLVideoElement)) {
        return;
    }

    const playPromise = player.play();

    if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {
            // Autoplay può essere bloccato dal browser: restano i controlli nativi.
        });
    }
}

function resetPlayer(player) {
    if (!(player instanceof HTMLVideoElement)) {
        return;
    }

    player.pause();
    player.currentTime = 0;
}

function initFlexcontentVideoModal() {
    const modals = document.querySelectorAll(MODAL_SELECTOR);

    if (!modals.length) {
        return;
    }

    modals.forEach((modal) => {
        // Il layout wide ha overflow:hidden: sposta la modale sul body.
        if (modal.parentElement !== document.body) {
            document.body.appendChild(modal);
        }

        modal.addEventListener("shown.bs.modal", () => {
            const player = getPlayer(modal);
            ensureSource(player);
            playPlayer(player);
        });

        modal.addEventListener("hidden.bs.modal", () => {
            resetPlayer(getPlayer(modal));
        });
    });
}

initFlexcontentVideoModal();
